function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.tipstory-st0{fill:url(#TIPSTORY_SVGID_1_);}\n\t.tipstory-st1{fill:#FFFFFF;}\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "tipstory-st0",
  d: "M256,33.9v199.1c0,0.4-0.2,0.8-0.6,0.9c-9.6,1.6-95.1-11.9-98.9-10.9c-11.9,0-22.3,4.7-28.5,11.9l0,0 c-6.2-7.2-16.6-11.9-28.5-11.9c-3.8-0.9-89.2,12.6-98.9,10.9c-0.4-0.1-0.7-0.5-0.6-0.9V33.9c0-0.4,0.2-0.8,0.7-0.9l89.4-10.7 l7.4-0.9l0,0c11.3-0.7,24.2,4.2,30.4,11.9c6.2-7.7,19.1-12.6,30.4-11.9l0,0l7.4,0.9l89.5,10.7C255.7,33,256,33.4,256,33.9z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "tipstory-st1",
  d: "M50.7,176.2V86.3h-30V62.3h86.1v24.1H77v89.9H50.7C50.7,176.3,50.7,176.2,50.7,176.2z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "tipstory-st1",
  d: "M219,100c4.9,3.8,8.7,8.9,10.9,14.8c2.7,6.9,4,14.4,3.9,21.9c0.1,7.4-1.2,14.7-3.9,21.6 c-2.2,5.7-6,10.6-10.8,14.3c-4.6,3.4-10.3,5.2-16,5c-4.3,0-8.5-1.1-12.3-3c-3.6-1.9-6.6-4.7-8.7-8.2v39.1h-25.2V96.6h24.8v10.2 c2-3.8,5-6.8,8.7-8.9c3.9-2.2,8.2-3.3,12.7-3.3C208.8,94.6,214.4,96.5,219,100z M205.3,151c2.3-3.4,3.5-8.1,3.5-14.4 c0-6.6-1.2-11.6-3.6-15.1c-3.9-5.6-11.6-6.9-17.1-3c-1.2,0.8-2.2,1.8-2.9,2.9c-2.3,3.5-3.6,8.4-3.6,14.8c0,6.3,1.2,11.3,3.6,14.6 c2.3,3.4,6.1,5.3,10.2,5C199.3,156.2,203.1,154.3,205.3,151z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "tipstory-st1",
  d: "M114.9,75.2c0-8.1,5.6-14.2,13-14.2s13.3,6.1,13.3,14.2s-5.8,14.1-13.3,14.1S114.9,83.3,114.9,75.2z M116,96.9 h23.9V177H116V96.9z"
});

function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 256 256",
    style: {
      enableBackground: "new 0 0 256 256"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "TIPSTORY_SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 267.9952,
    x2: 256,
    y2: 267.9952,
    gradientTransform: "matrix(1 0 0 -1 0 395.9952)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0097F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    style: {
      stopColor: "#0097F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    style: {
      stopColor: "#0097F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#0083F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    style: {
      stopColor: "#0097F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "#0097F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0097F4"
    }
  }))), _ref3, _ref4, _ref5, _ref6));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.4586adb3.svg";
export { ForwardRef as ReactComponent };